import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";
import { api, apiErr } from "@/lib/api";
import { DayStats } from "@/pages/staff/RockCrew";
import { DaytimeManualBook } from "./DaytimeManualBook";

function AdminRow({ r, onChange }) {
  const cancel = async () => {
    if (!window.confirm(`Cancel ${r.child_name}'s booking? (Admin cancel always restores the visit)`)) return;
    try { const { data } = await api.post(`/daytime/admin/bookings/${r.id}/cancel`); toast.success(data.message || "Cancelled"); onChange(); } catch (e) { toast.error(apiErr(e)); }
  };
  const move = async () => {
    const d = window.prompt("Move to which date? (YYYY-MM-DD)", r.date);
    if (!d || d === r.date) return;
    const over = window.confirm("Override capacity/closed status if needed?");
    try { await api.post(`/daytime/admin/bookings/${r.id}/move`, { date: d, override: over }); toast.success("Booking moved"); onChange(); } catch (e) { toast.error(apiErr(e)); }
  };
  return (
    <div className="bg-white border border-slate-200 rounded-2xl p-3 flex flex-wrap items-center justify-between gap-2" data-testid={`dt-admin-row-${r.id}`}>
      <div>
        <p className="font-bold text-navy">{r.child_name} <Badge variant="outline" className="ml-1 capitalize">{r.status.replace("_", " ")}</Badge> {!r.paid && <Badge className="bg-coral text-white ml-1">Unpaid</Badge>}</p>
        <p className="text-xs text-slate-500">{r.parent_name} · {r.parent_phone || r.parent_email} · {r.type_label}{r.visits_remaining != null ? ` · ${r.visits_remaining} visits left` : ""}</p>
      </div>
      {r.status === "booked" && <div className="flex gap-1.5">
        <Button size="sm" variant="outline" className="rounded-full" onClick={move} data-testid={`dt-move-${r.id}`}>Move</Button>
        <Button size="sm" variant="outline" className="rounded-full text-coral" onClick={cancel} data-testid={`dt-cancel-${r.id}`}>Cancel</Button>
      </div>}
    </div>
  );
}

export function DaytimeDayView() {
  const nav = useNavigate();
  const [date, setDate] = useState(new Date().toLocaleDateString("en-CA", { timeZone: "Atlantic/Bermuda" }));
  const [data, setData] = useState(null);
  const load = useCallback(() => { api.get(`/daytime/admin/day?date=${date}`).then((r) => setData(r.data)).catch((e) => toast.error(apiErr(e))); }, [date]);
  useEffect(() => { load(); }, [load]);
  return (
    <div className="grid lg:grid-cols-[1.4fr_1fr] gap-5 mt-3">
      <div className="space-y-3">
        <div className="flex flex-wrap items-center gap-2">
          <Input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="rounded-xl w-44" data-testid="dt-admin-date" />
          <Button variant="outline" className="rounded-full" onClick={() => nav("/staff/daytime")} data-testid="dt-open-crew">Open Today's Rock Crew</Button>
        </div>
        {data && <DayStats stats={data.stats} />}
        <div className="space-y-2">{data?.rows.map((r) => <AdminRow key={r.id} r={r} onChange={load} />)}</div>
        {data && data.rows.length === 0 && <p className="text-sm text-slate-400">No Daytime bookings this day.</p>}
      </div>
      <DaytimeManualBook date={date} onDone={load} />
    </div>
  );
}
